import React from 'react'

import CommentItemContainer from '../../containers/comments/comment-item-container'
import CreateWorkOrderCommentContainer from '../../containers/comments/create-work-order-comment-container'

export default ({
  workOrder,
  comments,

  hasNextPage,
  onLoadNextPage
}) => (
  <div className='list work-order-comments'>
    <CreateWorkOrderCommentContainer workOrderId={workOrder.id} />

    {comments.map(comment =>
      <CommentItemContainer key={comment.id} commentId={comment.id} />
    )}

    {hasNextPage &&
      <div className='card load-more' onClick={onLoadNextPage}>
        Load more...
      </div>}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/comments/work-order-comments.js